import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  Flex,
  Typography,
  Button,
  Form,
  Input,
  Row,
  Col,
  Alert,
  Spin,
} from "antd";

import { activate_wa, activate_email } from "src/redux/actions/auth";
import { clearMessage } from "src/redux/actions/message";

import swal from "sweetalert";
const { Title, Text } = Typography;
const App = ({ via, email, wa, setCurrent }) => {
  const [loading, setLoading] = useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.message);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(clearMessage());
  }, []);
  if (isLoggedIn) {
    return <Navigate to="/" />;
  }

  const onFinish = (values) => {
    console.log("Received values from form: ", values);

    setLoading(true);
    if (!loading) {
      if (via == "email") {
        dispatch(activate_email(email, values.kode))
          .then(() => {
            swal("Success", "success", "success", {
              buttons: false,
              timer: 2000,
            });
            window.setTimeout(() => {
              //setSuccess(true);
              setLoading(false);
              setCurrent(3);
              //window.location.reload();
            }, 2000);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        dispatch(activate_wa(wa, values.kode))
          .then(() => {
            swal("Success", "success", "success", {
              buttons: false,
              timer: 2000,
            });
            window.setTimeout(() => {
              //setSuccess(true);
              setLoading(false);
              setCurrent(3);
              //window.location.reload();
            }, 2000);
          })
          .catch(() => {
            setLoading(false);
          });
      }
    }
  };
  const onChange = (text) => {
    console.log("onChange:", text);
  };
  const sharedProps = {
    onChange,
  };
  return (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Col style={{ width: "50%" }}>
        <Flex gap="middle" align="flex-start" vertical>
          <Title level={5}>Masukkan Kode OTP Anda</Title>
          <Text>
            Kode OTP dikirim ke {via == "email" ? email : wa}, masa berlaku kode
            tersebut adalah 5 menit.
          </Text>
          <Form
            name="login_form"
            initialValues={{ remember: true }}
            onFinish={onFinish}
          >
            <Form.Item
              name="kode"
              rules={[
                { required: true, message: "Tolong masukkan kode OTP Anda!" },
              ]}
            >
              <Input.OTP length={6} {...sharedProps} />
            </Form.Item>
            {!loading && message && (
              <Alert
                message={message}
                type="error"
                showIcon
                style={{ marginBottom: "16px" }}
              />
            )}
            <Form.Item>
              <Spin spinning={loading} delay={100}>
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  shape="round"
                >
                  Activate
                </Button>
              </Spin>
            </Form.Item>
          </Form>
        </Flex>
      </Col>
    </Row>
  );
};
export default App;
